define('modules/editor/views/main',['require','exports','module','backbone','base/layout','base/vent','../models/editorstate','common/models/appstate','modules/lp_info/models/page','../../../lib/util','./toolbar','./sidebar','./page','common/views/alert_view','common/views/notice_view','common/views/header_view_mdheader','common/views/footer_view_mdfooter','common/views/sidebar_view_mdsidebar','common/views/notice_view_mdnotice','common/views/chatbot_view','common/views/reminders_view_mdreminders','common/views/loading_view','common/views/404','common/views/trial_view','common/views/confirmation_popup','ThemesHelper','./content_copy_popup','./content_copy_popup','./new_popup_modal','fontmanager','ldsh!../templates/main'],function (require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
    Layout = require('base/layout'),
    Vent = require('base/vent'),
    EditorState = require('../models/editorstate'),
    MoveState = EditorState.moveState,
    GroupState = EditorState.groupState,
    AppState = require('common/models/appstate'),
    Page = require('modules/lp_info/models/page'),
    util = require('../../../lib/util'),
    ToolbarView = require('./toolbar'),
    SidebarView = require('./sidebar'),
    PageView = require('./page'),
    AlertView = require('common/views/alert_view'),
    NoticeView = require('common/views/notice_view'),
    HeaderViewMDHeader = require('common/views/header_view_mdheader'),
    FooterViewMDFooter = require('common/views/footer_view_mdfooter'),
    SidebarViewMDSidebar = require('common/views/sidebar_view_mdsidebar'),
    NoticeViewMDNotice = require('common/views/notice_view_mdnotice'),
    ChatbotView = require('common/views/chatbot_view'),
    RemindersViewMDReminders = require('common/views/reminders_view_mdreminders'),
    LoadingView = require('common/views/loading_view'),
    View404 = require('common/views/404'),
    TrialView = require('common/views/trial_view'),
    ConfirmationPopup = require('common/views/confirmation_popup'),
    ThemesHelper = require('ThemesHelper');

  var newStepModal = {
    step: require('./content_copy_popup'),
    confirmation: require('./content_copy_popup'),
    popup: require('./new_popup_modal'),
  };

  var FontManager = require('fontmanager');

  var KEYS = {
    BACK: 8,
    SHIFT: 16,
    DEL: 46,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    C: 67,
    V: 86,
    ESC: 27,
  };

  /**

  Basically a big layout, owner of the Variant model. All interactions
  are event based: either model events, this.ViewState events, or
  Vent events sent from child components (i.e. the sidebar / toolbar).

  **/
  module.exports = Layout.extend({
    template: require('ldsh!../templates/main'),

    regions: {
      header: '.js-header',
      footer: '.js-footer',
      toolbar: '.js-toolbar',
      sidebar: '.js-aside',
      mdSidebar: '.js-mdSidebar',
      mdNotice: '.js-mdNotice',
      notice: '.js-ed-notice-box',
      elementsTree: '.elements-tree',
      page: '.js-page',
      modals: '#modals',
      expire: '.js-expire',
      reminders: '.js-reminders',
      chatBot: '.js-chatBot',
    },

    events: {
      'click .js-add-step': 'addStep',
      'click .js-add-popup': 'addPopup',
    },

    initialize: function () {
      this.vent = new Vent();
      this.page = new Page({ id: this.options.pageId });
      this.viewState = new Backbone.Model();
      this.unsavedChangesMessages = $.i18n.t('editor.unsavedChanges');

      this.listenTo(EditorState, EditorState.CURRENT_STEP_CHANGE, this.onTabChange);
      this._addVentEvents();
      this._addModelEvents();

      //show loading
      this.regions.page.show(new LoadingView());

      //Save reference in EditorState
      EditorState.setVariant(this.model);
      //Select the Active Page once steps collection has been set
      this.model.content.once('reset', function (collection) {
        EditorState.setActivePage(collection.getContent());
      });
      //Set localized unsaved changes messages
      AppState.setNavigationConfirmMessage(this.unsavedChangesMessages);

      AppState.onExpiration(_.bind(this.showTrial, this));
      AppState.onReminder(_.bind(this.showReminder, this));

      this.model.fetch({
        success: _.bind(this._onVariantLoaded, this),
        error: _.bind(this._onLoadError, this),
      });

      this.bodyClasses = this._getBodyClasses();
    },

    _getBodyClasses: function () {
      var currentTheme = ThemesHelper.getCurrentTheme();
      var classes = ['ed-landing-editor', 'editor', '_' + currentTheme];

      return classes;
    },

    /** Handles unsuccessful model fetch **/
    _onLoadError: function (nop, response) {
      if (response.status === 404) {
        this._show404();
      } else {
        var message = $.i18n.t('editor.loadError');
        this._showNotification({
          success: false,
          message: message,
        });
      }
    },

    /** Once the variant is loaded, setup UI details **/
    _onVariantLoaded: function () {
      //nofity services of variant loaded to get variant_id
      this.trigger('variant:ready', this.model);
      this._includeCustomFonts();
      //include custom styles
      var activePage = EditorState.getActivePage();
      if (activePage) this._updateCustomStyles(activePage.styles.toJSON());
      //start keyboard listeners
      this._attachKeyboardListeners();
      EditorState.setUniqueId(this.model.getHighestId());
      EditorState.setAMPState(this._checkAMPState());
    },

    /** Handles successful model save **/
    _onSaveOk: function () {
      var message = $.i18n.t('editor.saveOk');
      // once the model has been saved, it's time to sync the steps collection
      this.model.content.fetch({
        reset: true,
        success: _.bind(function () {
          EditorState.setVariantChanged(false);
          EditorState.setUniqueId(this.model.getHighestId());
          //on reset, reload the model on editor
          EditorState.setCurrentStep(EditorState.getCurrentStep(), true);
          EditorState.trigger('rerenderTree');
          this.vent.trigger('variant:saved');
          this._showNotification({
            success: true,
            message: message,
          });
        }, this),
      });
    },

    _showCheckingURLsError: function (error) {
      var response = error.responseJSON,
        messageBody = response.detail,
        notificationParams = {
          autoHide: false,
          message: messageBody,
          templateExtended: true,
        };

      this._showNotification(notificationParams);
      return;
    },

    _checkingIfURLsAreNotAccepted: function (status) {
      return status === 406;
    },

    /** Handles unsuccessful model save **/
    _onSaveError: function (error) {
      var message = $.i18n.t('editor.saveError');

      if (this._checkingIfURLsAreNotAccepted(error.status)) {
        this._showCheckingURLsError(error);
      } else {
        this._showNotification({
          success: false,
          message: message,
          autoHide: false,
        });
      }
    },

    addStep: function (e) {
      e.preventDefault();
      var model = this.model.content.addStep();
      EditorState.setCurrentStep(model.get('step'), true);
    },

    addPopup: function (e) {
      e.preventDefault();
      var model = this.model.content.addPopup();
      EditorState.setCurrentStep(model.get('step'), true);
    },

    /** Handles viewState change:tab event **/
    onTabChange: function (stateModel, step) {
      this.model.activeItemState.deselect();
      var editableModel = this.model.getContentForStep(step),
        originModel = this.model.getContentForStep(+step - 1),
        stepType = this.model.getStepType(step);

      $('body').toggleClass('editor-confirm', this.model.isConfirmationStep(step));

      if (originModel.sections.length && !editableModel.sections.length) {
        newStepModal[stepType]
          .show()
          .then(
            function () {
              var options;
              if (this.model.isConfirmationStep(step)) options = { omit: 'element:form' };
              var sections = originModel.selfClone(options);
              editableModel.sections.reset(sections);
              EditorState.setVariantChanged(true);
            }.bind(this)
          )
          .always(
            function () {
              this.updateTabContent(editableModel, step);
            }.bind(this)
          );
      } else {
        this.updateTabContent(editableModel, step);
      }
    },
    updateTabContent: function (editableModel, step) {
      var customStyles = editableModel.styles.toJSON();
      //set active page
      EditorState.setActivePage(editableModel);
      this._setupViews(step);
      //this._updateEditingPage(editableModel, step);
      //editableModel.notifyHistoryStatus();
      // Custom CSS changes from Content Tab to Confirmation Tab
      this._updateCustomStyles(customStyles);
    },
    /** Save Variant Model **/
    saveVariant: function () {
      EditorState.activeItemState.deselect();
      var activePage = EditorState.getActivePage();
      var pageHtml = this.model.services.request('page:render', this.model);
      var message = $.i18n.t('common.savingText');
      var self = this;

      EditorState.setActivePage(activePage);
      this.model.unsetWeight();

      _.each(pageHtml, this.model.setStepHtml, this.model);

      var savedNotification = this._showNotification({
        success: true,
        message: message,
        autoHide: false,
        persist: true,
      });

      this.model.save(null, {
        patch: true,
        success: function () {
          savedNotification.hide();
          self._onSaveOk();
        },
        error: function (constructor, error) {
          savedNotification.hide();
          self._onSaveError(error);
        },
        //NOTE: custom option, see variant parse
        saved: true,
      });
    },
    reloadVariant: function () {
      EditorState.activeItemState.deselect();
      // var activePage = EditorState.getActivePage();
      // var pageHtml = this.model.services.request("page:render", this.model);
      //
      // EditorState.setActivePage(activePage);
      // this.model.unsetWeight();
      //
      // _.each(pageHtml, this.model.setStepHtml, this.model);

      EditorState.setCurrentStep(EditorState.getCurrentStep(), true);
      EditorState.trigger('rerenderTree');
    },

    undoVariant: function () {
      var step = EditorState.getCurrentStep(),
        model = this.model.getContentForStep(step);
      model.undo();
    },

    redoVariant: function () {
      var step = EditorState.getCurrentStep(),
        model = this.model.getContentForStep(step);
      model.redo();
    },

    /** Setup Layout regions **/
    _setupViews: function (step) {
      var model = this.model.getContentForStep(step),
        extraModel = new Backbone.Model({
          pageId: this.model.get('pages_id'),
          name: this.model.get('name'),
        });
      this.page.fetch({
        success: _.bind(function (page) {
          this.regions.toolbar.show(
            new ToolbarView({
              model: extraModel,
              data: model,
              vent: this.vent,
              page: page,
            })
          );
          //this._updateEditingPage(model, step);
        }, this),
        error: function () {
          console.log('There was an error fetching the page');
        },
      });

      var HeaderView = HeaderViewMDHeader,
        FooterView = FooterViewMDFooter,
        MDSidebarView = SidebarViewMDSidebar,
        MDNoticeView = NoticeViewMDNotice;

      this.regions.sidebar.show(
        new SidebarView({ model: extraModel, data: model, vent: this.vent })
      );

      this.regions.page.show(
        new PageView({ collection: model.sections, data: model, target: step })
      );

      this.regions.header.show(new HeaderView({ editor: true }));
      this.regions.footer.show(new FooterView({ editor: true }));
      this.regions.mdSidebar.show(new MDSidebarView());
      this.regions.mdNotice.show(new MDNoticeView());
      this.regions.chatBot.show(new ChatbotView());
      this._noticeView = new NoticeView();
      this.regions.notice.show(this._noticeView);

      $('#md__sidebar__wrapper').addClass('collapsed');
    },

    /** localize the view **/
    onRender: function () {
      this.$el.i18n();
      this._adjustSidebarHeight();
      this._updateEditorStyles(this.model.getPropertyGroup('page:defaults').toJSON());
      $(window).on('resize', _.bind(this._adjustSidebarHeight, this));
      $(window).on('resize', util.adjustTabs);
    },

    onRemove: function () {
      $(window).off('resize', _.bind(this._adjustSidebarHeight, this));
      $(window).off('resize', util.adjustTabs);
    },

    _checkAMPState: function () {
      return util.isVariantAMP(this.options.model);
    },

    _adjustSidebarHeight: function () {
      var sidebar = this.$('.ed-aside'),
        height = sidebar.innerHeight();

      sidebar.toggleClass('low-height', height < 758);
    },

    /** Set up Event aggregator listeners **/
    _addVentEvents: function () {
      this.listenTo(this.vent, 'variant:save', this.saveVariant);
      this.listenTo(this.vent, 'variant:reload', this.reloadVariant);
      this.listenTo(this.vent, 'save:ok', this.showOkNotification);
      this.listenTo(this.vent, 'save:error', this.showErrorNotification);
      this.listenTo(this.vent, 'edit:scripts', function () {
        EditorState.getActivePage().editScripts();
      });
      this.listenTo(this.vent, 'edit:styles', function () {
        EditorState.getActivePage().editStyles();
      });
      this.listenTo(this.vent, 'edit:seo', function () {
        EditorState.getActivePage().editSEO();
      });
      this.listenTo(this.vent, 'page:preview', function () {
        this.model.services.request('page:preview', this.model);
      });
      this.listenTo(this.vent, 'variant:undo', this.undoVariant);
      this.listenTo(this.vent, 'variant:redo', this.redoVariant);
    },

    /** Set up Model event listeners **/
    _addModelEvents: function () {
      //only after variant is loaded
      this.model.once(
        'sync',
        _.bind(function () {
          //this.viewState.set("tab", "content");
          var step = EditorState.getCurrentStep();
          this._setupViews(step);
          EditorState.setVariantChanged(false);
          // we need to force the first SAVE to generate the HTML and send
          // it to the server, specially if the variant has been created from
          // a template (in that case, we have the JSON but not the HTML yet)
          if (this.model.isEmpty) {
            //change editor state (will handle navigation)
            EditorState.setVariantChanged(true);
          }
        }, this)
      );

      //page default properties
      this.listenTo(this.model, 'change:page:defaults', function (model) {
        if (model) {
          this._updateEditorStyles(model.toJSON());
        }
        // not needed since property groups changes fire the same method on EditorState
        //EditorState.setVariantChanged(true);
      });

      //page user-defined styles
      this.listenTo(this.model, 'variant:change:styles', this._updateCustomStyles);
      //page form confirmation behaviour
      this.listenTo(
        this.model,
        'change:page:popup change:page:confirmation change:page:privacy change:page:notification change:page:conversion change:page:gtm',
        function () {
          EditorState.setVariantChanged(true);
        }
      );
      //page SEO
      this.listenTo(
        this.model,
        'variant:change:seo variant:change:styles variant:change:scripts',
        function () {
          EditorState.setVariantChanged(true);
        }
      );

      // to commit undo/redo is like loading a variant again
      this.listenTo(this.model, 'history:commit', this._onVariantLoaded);
    },

    _getNotificationType: function (params) {
      if (params.success) {
        return 'success';
      }

      return 'danger';
    },

    /** Shows a page notification **/
    _showNotification: function (params) {
      params.alertType = this._getNotificationType(params);

      return AlertView.showAlert(params);
    },

    _showNotice: function (text) {
      this._noticeView.showNotice(text);
    },

    /** Shows trial nag bar **/
    showTrial: function () {
      this.regions.expire.$el.addClass('ed-expire');
      this.regions.expire.show(new TrialView());
    },
    showReminder: function () {
      this.regions.reminders.show(new RemindersViewMDReminders());
    },

    _show404: function () {
      var HeaderView = HeaderViewMDHeader,
        MDSidebarView = SidebarViewMDSidebar,
        MDNoticeView = NoticeViewMDNotice;

      this.regions.page.show(new View404());
      this.regions.page.currentView.$('a').attr('data-bypass', '');
      this.regions.header.show(new HeaderView());
      this.regions.sidebar.$el.remove();
      this.regions.toolbar.$el.remove();
      this.regions.mdSidebar.show(new MDSidebarView());
      this.regions.mdNotice.show(new MDNoticeView());
      this.regions.chatBot.show(new ChatbotView());
    },

    /** Update page properties styles on page **/
    _updateEditorStyles: function (attrs) {
      var $styleTag = this.$('#pageStyles');
      var content = '';
      // content += ".ed-wrapper { background-color: " + attrs.backgroundColor + "; color: " + attrs.color + "; padding-top: " + attrs.marginTop + "px; }\n";
      content +=
        'body { background-color: ' +
        attrs.backgroundColor +
        ' !important; color: ' +
        attrs.color +
        '; }\n';
      content +=
        '.ed-wrapper { background-color: ' +
        attrs.backgroundColor +
        '; color: ' +
        attrs.color +
        '; }\n';
      content += '.lpg-page { font-family: "' + attrs.fontFamily + '"; }\n';
      content += '.ed-panel { width: ' + parseInt(attrs.width) + 'px; }\n';
      content += '.ed-panel a { color: ' + attrs.linkColor + '  ;}\n';

      $styleTag.empty().text(content);
      this.model.trigger('change', this.model);
    },

    _includeCustomFonts: function () {
      this.$('link[data-font]').attr('href', FontManager.getCustomFontsLink());
    },

    /** Update user-defined CSS on page **/
    _updateCustomStyles: function (stylesArray) {
      var $userStyleTag = this.$('#customStyles'),
        $externalStyleTag = this.$('#externalStyles');
      var content = '';
      if (!$userStyleTag) {
        return;
      }
      _.each(stylesArray, function (styleObj) {
        if (!styleObj.isTag) content += styleObj.content + '\n';
      });
      var externalStyles = _.where(stylesArray, { isTag: true }),
        styles = _.reduce(
          externalStyles,
          function (styles, style) {
            return (styles += style.content + '\n');
          },
          ''
        );

      $userStyleTag.empty().text(content);
      $externalStyleTag.empty().append(styles);
    },

    /** keyboard listeners to move /resize selected element with arrow keys **/
    _attachKeyboardListeners: function () {
      function canDeleteOnKeyPress() {
        return !EditorState.get('modalOpen') && !AppState.isPropsPopUpOpen();
      }

      $(document).on(
        'keydown',
        _.bind(function (e) {
          if (!AppState.isPropsPopUpOpen()) {
            // when there are editors open, do nothing
            this._runCopyPaste(e);
            this._runMoveResize(e);
          }
        }, this)
      );

      $(document).on(
        'keyup',
        _.bind(function (e) {
          var key = e.keyCode;

          switch (key) {
            case KEYS.SHIFT:
              // when Shift's up, stop movement
              e.preventDefault();
              MoveState.stopMoving();
              break;

            case KEYS.BACK:
            case KEYS.DEL:
              e.preventDefault();
              canDeleteOnKeyPress() &&
                ConfirmationPopup.show({
                  title: $.i18n.t('editor.confirmItemDeletion.title'),
                  message: $.i18n.t('editor.confirmItemDeletion.message'),
                }).then(function () {
                  EditorState.getActivePage().deleteSelectedItem();
                });
              break;
            case KEYS.ESC:
              // Closing modals
              e.preventDefault();
              EditorState.setModalOpen(false);
              $('.js-close').trigger('click');
              $('.js-tooltip.in').removeClass('in');
          }
        }, this)
      );
    },

    _runMoveResize: function (e) {
      var dX = 0,
        dY = 0,
        fineGrain = e.shiftKey,
        delta = fineGrain ? 1 : 10,
        operation = e.altKey || e.metaKey ? 'resize' : 'move',
        selectedElement = EditorState.getSelectedElement();

      if (this._isArrowKey(e)) {
        e.preventDefault();
      }

      if (selectedElement && selectedElement.model && selectedElement.model.name === 'section') {
        return;
      }

      EditorState.deselect();

      switch (e.keyCode) {
        case KEYS.UP:
          //move up or make shorter
          dY -= delta;
          break;
        case KEYS.DOWN:
          //move down or make taller
          dY += delta;
          break;
        case KEYS.LEFT:
          //move left or make narrower
          dX -= delta;
          break;
        case KEYS.RIGHT:
          //move right or make wider
          dX += delta;
          break;
      }

      if (operation === 'move' && fineGrain) {
        MoveState.startMoving(GroupState.getFirstView(), { x: 0, y: 0 });
      }
      if (operation === 'move') {
        GroupState.updateModelsPosition(dX, dY);
        if (fineGrain) {
          MoveState.setLastPosition(GroupState.getGroupAbsoluteDimensions());
        }
      } else if (operation === 'resize') {
        GroupState.updateModelsSize(dX, dY);
      }

      EditorState.selectElement(GroupState.getFirstView());

      // When Shift's up, stop movement
      if (e.keyCode === KEYS.SHIFT) {
        e.preventDefault();
        MoveState.stopMoving();
      }
    },

    _runCopyPaste: function (e) {
      if (e.ctrlKey || e.metaKey) {
        if (e.keyCode === KEYS.C) {
          // keyCode: c
          this.model.services.request('copyPaste:copy', this._showNotice.bind(this));
        } else if (e.keyCode === KEYS.V) {
          // keyCode: v
          this.model.services.request('copyPaste:paste', this._showNotice.bind(this));
        }
      }
    },

    _isArrowKey: function (e) {
      return [KEYS.LEFT, KEYS.UP, KEYS.RIGHT, KEYS.DOWN].indexOf(e.keyCode) >= 0;
    },
  });
});

